import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { VolunteerOrganizationContact } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrganizationContact>();

export class VolunteerOrganizationContactFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrganizationContact>
  >((filters) =>
    filterWithRelationsAndJson(VolunteerOrganizationContact)(filters),
  );
}
